// Widget Scripts
import cardemail from './js/widgets/cardemail.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidget from './js/widgets/cardWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import map from './js/widgets/Map.js';
import cardsponsortitle from './js/widgets/cardsponsortitle.js';
import cardWidgetSponsor from './js/widgets/cardWidgetSponsor.js';
import cardsponsorsecondtitle from './js/widgets/cardsponsorsecondtitle.js';
import cardWidgetsecondSponsor from './js/widgets/cardWidgetsecondSponsor.js';
import cssSponsors from './js/widgets/cssSponsors.js';
import cardWidgetFooter from './js/widgets/cardWidgetFooter.js';
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    cardemail();
    swiperWidget();
    cardWidget();
    map();
    cardWidgetSponsor();
    cardWidgetsecondSponsor();
    cardsponsortitle();
    cardsponsorsecondtitle();
    cssSponsors();
    
  });
}

// initialize site-wide widgets
$(document).ready(function () {
  cardWidgetFooter();
});

$(window).load(function () {
  videoWidget();
});